
<template>


  <div class="signup app-content bg-gray">
    <div class="bg-blue pb-5">
      <div class="container bg-blue">
        <div class="row mx-0 pb-2">
          <div class="col-12 p-0">
            <router-link :to="'./job_mypage'">
              <p class="text-dark font14 under" style="display: inline;">{{$t("message.top")}}</p>
            </router-link>
            <p class="mx-1 text-dark font14" style="display: inline;"> > </p>
            <router-link :to="'./recruits'">
              <p class="text-dark font14 under" style="display: inline;">お誘いがあった企業</p>
            </router-link>
          </div>
        </div>
        <div class="row pt-4 mb-2">
          <div class="col-12">
            <router-link :to="'./jobs'">
              <p class="pt-3">＜ 前に戻る</p>
            </router-link>
          </div>
        </div>
      </div>
      <div class="container px-5">

        <div class="row pt-4 mb-2 px-5">
          <div class="d-flex justify-content-between pb-2">
            <p class="mb-0 job-dashboard-title"><b-icon class="h5 mb-0 mt-2 mr-2" icon="question-circle" style='color: gray'></b-icon>お誘いがあった企業</p>
          </div>
          <div v-for="recruit in recruits" :key="recruit.id" class="col-12 px-0 bg-white mb-3">
            <div class="card shadow-sm">
              <div class="card-body">
                <p class="card-text">{{ recruit.message }}</p>

                <hr/>


                <div class="row">
                  <div class="col-9">
                    <p class="card-text mb-1 pt-0">{{ recruit.name }}</p>
                    <small> [職種: 正]{{ occupactionDict[recruit.occupation] }}<br/>勤務地：{{ recruit.location }}</small><br/>
                    <small class="">{{ salaryOptions[recruit.employment_form] }}: {{ salaryParse(recruit, 'min') }} 〜 {{ salaryParse(recruit, 'max') }}万円</small>

                    <br/>
                    <a type="button" :href="'jobs/' + recruit.job_id" class="btn btn-sm btn-outline-primary mt-2 mx-1 px-5">詳しくみる</a>
                  </div>
                  <div class="col-3">
                    <div class="sample-box"></div>
                  </div>

                </div>
                  <hr/>
                  <p class="text-center recruit-chat-message pb-2 pt-2">こちらの企業とチャットでお話してみますか？</p>
                  <div class="col-12 text-center pb-4">
                    <b-button pill @click="applyScout(recruit)" class='orange-button py-2 px-5'>承諾する</b-button>
                    <b-button pill @click="rejectScout(recruit)"  class='gray-button2 py-2 px-5'> 承諾しない </b-button>
                  </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>








</template>

<script>
import { mapState } from 'vuex';
import axios from 'axios';

export default {
  components: {
  },
  data () {
    return {
      recruits: [],
      idToken: localStorage.idToken,
      salaryOptions: {
        'hourt': '時給' ,
        'week': '週給',
        'month': '月給' ,
        'year': '年収' ,
      },
      occupactionDict: {
        "full": this.$i18n.t('message.full_time_employee'),
        "part": this.$i18n.t('message.part_time_job'),
        "temporary": this.$i18n.t('message.temporary_staff'),
        "contract": this.$i18n.t('message.contract_employee')
      },
    }
  },
  methods: {
    fetch_jobs: function() {
      axios
      .get(process.env.VUE_APP_API + "/api/seeker/recruits" ,{headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
        this.recruits = response.data.recruits
      }).catch(error => {
        console.log('this is error', error)
      })
    },
    applyScout: function(recruit) {
      axios
        .patch(process.env.VUE_APP_API + "/api/seeker/recruits/" + recruit.id, {is_approve: true}, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
          this.recruits = response.data.recruits
          this.$swal.fire({
            title: 'スカウトを承認しました',
            text: "マッチングが成立しました",
            icon: 'success',
          })
        }).catch(error => {
          console.log('this is error', error)
        })
    },
    rejectScout: function(recruit) {
      axios
        .patch(process.env.VUE_APP_API + "/api/seeker/recruits/" + recruit.id, {is_approve: false}, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
          this.recruits = response.data.recruits
          this.$swal.fire({
            title: 'スカウトを拒否しました',
            icon: 'success',
          })
        }).catch(error => {
          console.log('this is error', error)
        })
    },
    salaryParse(job, t) {
      if(job.salary != null){
        var salary_list = job.salary.split('~')
        if(t == "min") {
          return salary_list[0]
        } else {
          return salary_list[1]
        }
      } else {
        return "-"
      }
    },
  },
  async mounted() {
    if( this.memberInfo.status == 'associate_member'){
      this.$router.push('./createUser')
    }else{
      if (this.memberInfo.status == "no_deposite_member") {
        //this.$router.push('./payment')
      }
    }
    this.fetch_jobs()
    this.$store.commit('setLoading', false)
  },

  computed: {
    ...mapState({
        memberInfo: state => state.user.user,
        language: state => state.language
    }),
  }
}
</script>

<style scoped lang="scss">
.thread-title{
  font-size: 1.3rem;
}
.black{
  color: #000000;
}
.next{
  background: #F29147;
  color: #FFFFFF;
  border-color: #F29147;
}

.sample-box {
  background-color: #EFEFEF;
  border: 1px solid #CDCDCD;
  height: 150px;
}
.recruit-chat-message {
  font-size: 20px;
}
.job-dashboard-title {
  font-size: 20px;
  font-weight: bold;
  color: #4E4E4E;
}
</style>
